import {RuleObject} from "antd/es/form";
import moment from "moment";
import dayjs from "dayjs";
import {CURRENCY_LOCALE, FORMAT_TIME, TT_PHIEU_KHAM} from "types/enums";
import {setCurrentRoom} from "redux/reducer/common";
import {isValidElement} from "react";
import axiosClient from "api/axiosClient";
import {Notification} from "components/common";
import {medicalExaminationService} from "api";
import React from "react";
import {array} from "yup";
import {daysToWeeks} from "date-fns";
import {log} from "console";

function formatNumber(number: number | string): string {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const formatDateToString = (
  date: Object,
  format = FORMAT_TIME.dayFull
): string => {
  const validDate = moment(date?.toString())?.isValid();
  return date && validDate
    ? moment(date?.toString()).format(format as string)
    : undefined;
};
const formatDate = (date, format = FORMAT_TIME.dayFullInputRevert) => {
  const validDate = moment(date?.toString()).isValid();
  return date && validDate
    ? moment(date?.toString()).format(format)
    : undefined;
};
const formatDateDelete = (date, format = FORMAT_TIME.dayFull) => {
  const validDate = moment(date?.toString()).isValid();
  return date && validDate
    ? moment(date?.toString()).format(format)
    : undefined;
};
// Quy thời gian sang múi +7 ví dụ: 1/1/2024 00:00:00 + 00:00 => 1/1/2024 00:00:00 +07:00
const formatDateOrStringToStringGMT_7 = (
  date: Object | string,
  format = FORMAT_TIME.dayFull
) => {
  const validDate = dayjs(date?.toString()).isValid();
  const diffWithGMT7 = 7 - dayjs().utcOffset() / 60;

  return date && validDate
    ? dayjs(date?.toString())
        .subtract(diffWithGMT7)
        .add(diffWithGMT7 == 0 ? 0 : 1, "second")
        .format(format as string)
    : null;
};
const formatToCurrencyTypeFloor = currency => {
  return currency
    ? `${Math.round(currency)?.toString()}`
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    : "";
};
const formatToCurrencyTypeNoFloor = currency => {
  // currency.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return currency
    ? `${currency?.toString()}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    : "";
};
const formatToCurrencyTypeToFixed = (
  currency,
  fixed = 0,
  type: any = CURRENCY_LOCALE.TYPE_JP
) => {
  return currency || currency == 0
    ? toNumber(currency).toLocaleString(type, {
        minimumFractionDigits: 0,
        maximumFractionDigits: fixed,
      })
    : "";
};
const formatDateToStringUnix = (date: Object): any => {
  const validDate = dayjs(date?.toString())?.isValid();
  console.log(date?.toString());
  console.log(dayjs(date?.toString()));
  return date && validDate ? dayjs(date?.toString()).unix() : null;
};
const formatToCurrencyType = currency => {
  return currency || currency == 0
    ? (currency < 0 ? "-" : "") +
        `${toNumber(currency)?.toFixed(0)?.toString()}`
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    : "";
};
const convertDateStringToDateTimezone_7DayjsNotValid = (
  date: string,
  fomart = "YYYY-MM-DDTHH:mm:ss"
) => {
  return date ? dayjs.utc(date, fomart).tz() : null;
};
const convertIosStringToDate = (dateString: string) => {
  return dateString ? dayjs(dateString, "YYYY-MM-DDTHH:mm:ss") : null;
};
const convertIosDateToString = (dateString: string) => {
  return dateString ? dayjs(dateString).format(FORMAT_TIME.dayFull) : null;
};
const convertIosStringToDate2 = (dateString: string) => {
  return dateString ? dayjs(dateString, "YYYY-MM-DDTHH:mm:ss.sssZ") : null;
};
const convertIosStringToDateMoment = (dateString: string) => {
  return dateString ? moment(dateString).format(FORMAT_TIME.dateTime) : null;
};
const convertIosStringToDateObjectDayjs = (dateString: string) => {
  return dateString ? dayjs(dateString) : null;
};
const convertIosStringToDateDayjs = (dateString: string, format = null) => {
  const isValid = format
    ? dayjs(dateString, format)?.isValid()
    : dayjs(dateString)?.isValid();
  const diffWithGMT7 = 7 - dayjs().utcOffset() / 60;
  console.log(isValid);
  return dateString && isValid
    ? format
      ? dayjs(dateString, format).add(diffWithGMT7, "hour")
      : dayjs(dateString).add(diffWithGMT7, "hour")
    : null;
  // }
};
//format lúc lấy vè cho các ô INPUT
const convertDateStringToDateTimezone_7 = date => {
  return date && dayjs(date)?.isValid() ? dayjs.utc(date).tz() : null;
};

//lúc gửi lên
const formatDateToStringTimezone_7 = (date: Date, convert: boolean) => {
  if (date && dayjs(date).isValid()) {
    //nếu lần đầu thì gửi thế này
    if (convert) {
      return dayjs.tz(date).format("YYYY-MM-DDTHH:mm:ss.sss+07:00");
    }
    //các lần update tiếp theo sẽ gửi như sau tánh tình trạng lấy giờ cũ xong tính
    else return dayjs(date).format("YYYY-MM-DDTHH:mm:ss.sss+07:00");
  } else return null;
};
//fomart cho nagyf ở table
const convertDateStringToDateTimezone_7Dayjs = (
  date: any,
  fomart: any = FORMAT_TIME.dateTime
) => {
  return date && dayjs(date).isValid()
    ? dayjs.utc(date).tz().format(fomart)
    : "";
};

const convertIosStringToDateObj = (dateString: string) => {
  const dateObject = new Date(dateString);
  const formattedDate = `${dateObject.toLocaleTimeString(undefined, {
    hour12: false,
  })} ${dateObject.toLocaleDateString()} `;
  return dateString && isValidElement(formattedDate) ? formattedDate : "--";
};
const convertDateStringToDateDayjs = (
  dateString: string | null,
  unix = false
) => {
  return dateString && dayjs(dateString)?.isValid()
    ? unix
      ? dayjs.unix(toNumber(dateString))
      : dayjs(dateString)
    : null;
};
const convertTimeSignatureToMins = (time1, time2) => {
  var hour, min, second;
  var totalSecond = (moment(time1).valueOf() - moment(time2).valueOf()) / 1000;

  hour = Math.floor(totalSecond / 3600);
  min = Math.floor((totalSecond - hour * 3600) / 60);
  second = totalSecond - 3600 * hour - 60 * min;

  if (hour >= 2) {
    hour = 2;
    min = "00";
    second = "00";
    return {hour, min, second};
  }
  // if (min >= 60) {
  //   min = 60;
  //   second = "00";
  //   return {hour, min, second};
  // }
  hour = "0" + hour;
  if (min < 10) {
    min = "0" + min;
  }
  if (second < 10) {
    second = "0" + second;
  }
  return {hour, min, second};
};
const getAge = ngaySinh => {
  if (ngaySinh) {
    return moment().year() - moment(ngaySinh).year();
  } else {
    return "--";
  }
};
const getBmi = (chieuCao, canNang) => {
  if (Number(chieuCao) > 0 && Number(canNang)) {
    const a = Number(chieuCao) / 100;
    const b = Number(canNang);
    return (b / (a * a)).toFixed(1);
  } else return "--";
};
const validatePhoneNumberLength = (_: RuleObject, value: string) => {
  if (value === "" || value === null || value === undefined) {
    return Promise.resolve();
  }
  const numericValue = Number(removeSpaces(value));
  if (!Number.isNaN(numericValue) && removeSpaces(value).length === 10) {
    return Promise.resolve();
  }
  return Promise.reject("Vui lòng nhập dãy số có độ dài là 10 số.");
};

const saveTableOptions = (tableKey, username, displayColumns) => {
  try {
    const savedJsonString = localStorage.getItem(tableKey);
    const savedData = JSON.parse(savedJsonString);
    if (savedData) {
      let data = savedData.map(dt => {
        if (dt.username === username) {
          return {username: username, displayColumns: displayColumns};
        } else return dt;
      });
      localStorage.setItem(tableKey, JSON.stringify(data));
    } else {
      localStorage.setItem(
        tableKey,
        JSON.stringify([
          {
            username: username,
            displayColumns: displayColumns,
          },
        ])
      );
    }
  } catch (err) {}
};
const getTableOptions = (tableKey, username) => {
  try {
    const savedJsonString = localStorage.getItem(tableKey);
    const savedData = JSON.parse(savedJsonString);
    if (savedData) {
      let tmp = savedData.filter(it => it.username === username);
      if (tmp.length > 0) {
        return tmp[0].displayColumns;
      } else return null;
    } else return null;
  } catch (err) {
    return null;
  }
};
const renderSTT = (index, page, limit) => {
  return index + 1 + (page - 1) * limit;
};
const normalizePhoneNumber = phoneNumber => {
  // Xóa khoảng trắng và dấu gạch ngang trong chuỗi số điện thoại (nếu có)
  const cleanPhoneNumber = phoneNumber.replace(/\s|-/g, "");

  // Kiểm tra xem số điện thoại có đủ độ dài hay không (10 chữ số)
  if (cleanPhoneNumber.length !== 10) {
    return null;
  }

  // Sử dụng RegExp để tách chuỗi thành các cụm 2 chữ số
  const normalizedPhoneNumber = cleanPhoneNumber.replace(
    /(\d{4})(\d{2})(\d{2})(\d{2})/,
    "$1 $2 $3 $4"
  );

  return normalizedPhoneNumber;
};
const removeSpaces = phoneNumberWithSpaces => {
  if (phoneNumberWithSpaces) {
    const phoneNumberWithoutSpaces = phoneNumberWithSpaces.replace(/\s/g, "");
    return phoneNumberWithoutSpaces;
  }
  // Xóa dấu cách trong chuỗi số để trở về định dạng ban đầu
  return phoneNumberWithSpaces;
};
const formatCodeField = (value: string) => {
  return value?.toString().toUpperCase();
};
const removeObjUndefined = obj => {
  if (obj) {
    Object.keys(obj).forEach(key => {
      if (obj[key] === undefined || obj[key] === "") {
        delete obj[key];
      }
    });
  }
  return;
};
const parseValueOfObjectToJson = object => {
  const listKey = Object.keys(object);

  listKey.forEach((key, index) => {
    object[key] = JSON.stringify(object[key]);
  });
};
const getTodayString = () => {
  const today = moment();
  const day = today.date();
  const month = today.month() + 1;
  const year = today.year();
  const time = today.format("HH:mm");
  return `${time} - Ngày ${day} tháng ${month} năm ${year}`;
};
const getDateStringLocale = (dateString: string) => {
  const validDate = moment(dateString).isValid();
  if (validDate) {
    const date = moment(dateString);
    const day = date.date();
    const month = date.month() + 1;
    const year = date.year();
    const time = date.format("HH:mm");
    return `Ngày ${day} tháng ${month} năm ${year}`;
  } else {
    return "";
  }
};

const getDateStringLocaleDetail = (dateString: string) => {
  const validDate = moment(dateString).isValid();
  if (validDate) {
    const date = moment(dateString);
    const day = date.date();
    const month = date.month() + 1;
    const year = date.year();
    const time = date.format("HH:mm");
    return `${time} Ngày ${day} tháng ${month} năm ${year}`;
  } else {
    return "";
  }
};

const dispatchCurrentRoom = (dispatch, trangThai, tenPhong) => {
  const listStatusActive = [
    TT_PHIEU_KHAM.DTH,
    TT_PHIEU_KHAM.CKQ,
    TT_PHIEU_KHAM.DCKQ,
    TT_PHIEU_KHAM.CTN,
  ];
  if (listStatusActive.includes(trangThai)) {
    dispatch(setCurrentRoom(tenPhong));
  } else {
    dispatch(setCurrentRoom(null));
  }
};
const objectWithoutProperties = (obj: any, keys: string[]) => {
  let target: any = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
};
const saveLocalValueByUser = (itemLocal: string, value) => {
  let itemLocalArray: any[] = JSON.parse(localStorage.getItem(itemLocal)) || [];
  const username = localStorage.getItem("username");
  const findIndex = itemLocalArray.findIndex(e => e?.username == username);
  if (findIndex == -1) {
    itemLocalArray.push({
      username: username,
      value: value,
    });
  } else {
    itemLocalArray[findIndex] = {username: username, value: value};
  }
  localStorage.setItem(itemLocal, JSON.stringify(itemLocalArray));
};
const getLocalValueUser = (itemLocal: string) => {
  let itemLocalArray: any[] = JSON.parse(localStorage.getItem(itemLocal)) || [];
  const username = localStorage.getItem("username");
  const findIndex = itemLocalArray.findIndex(e => e?.username == username);
  if (findIndex == -1) {
    return null;
  } else {
    return itemLocalArray[findIndex]?.value;
  }
};
const checkEmptyObj = (obj): boolean => {
  let isEmpty = true;
  if (!obj) {
    isEmpty = true;
    return isEmpty;
  }
  if (Object.keys(obj).length === 0) {
    isEmpty = true;
  } else {
    for (var prop in obj) {
      if (obj[prop]) {
        isEmpty = false;
      }
    }
  }
  return isEmpty;
};
const generateFileName = (baseName, fileExtension) => {
  const currentDate = new Date();
  const day = currentDate.getDate().toString().padStart(2, "0");
  const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
  const year = currentDate.getFullYear().toString();

  return `${baseName}-${day}-${month}-${year}.${fileExtension}`;
};
const generateFileNameZip = (baseName, fileExtension, month) => {
  return `${baseName}${month}.${fileExtension}`;
};

//format valid date
function parseDate(input: string) {
  const parts = input.includes("-") ? input.split("-") : input.split("/");
  // Lưu ý: JavaScript đếm tháng từ 0-11 nên phải trừ đi 1 ở phần tháng
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // Tháng bắt đầu từ 0
  const year = parseInt(parts[2], 10);
  return new Date(year, month, day);
}

const birthday2Age = (datetime, formart = false) => {
  if (datetime) {
    let birthday: any;
    if (formart) {
      birthday = parseDate(datetime);
    } else birthday = new Date(datetime);
    const currentDate: any = new Date();
    const ageInMilliseconds = currentDate - birthday;

    const ageInMonths = Math.floor(
      ageInMilliseconds / (30 * 24 * 60 * 60 * 1000)
    ); // 30 ngày trong một tháng
    if (ageInMonths < 12) {
      return `${ageInMonths} tháng`;
    } else if (birthday.getFullYear() !== currentDate.getFullYear()) {
      let ageInYears = currentDate.getFullYear() - birthday.getFullYear();
      // if (
      //   birthday.getMonth() > currentDate.getMonth() ||
      //   (birthday.getMonth() === currentDate.getMonth() &&
      //     birthday.getDate() > currentDate.getDate())
      // ) {
      //   ageInYears--;
      // }
      return ageInYears;
    }
  } else {
    return "";
  }
};

const birthday2AgeForConsultance = datetime => {
  if (datetime) {
    const parts = datetime.split("/");
    const formattedDate = parts[1] + "/" + parts[0] + "/" + parts[2];

    const birthday: any = new Date(formattedDate);
    const currentDate: any = new Date();
    const ageInMilliseconds = currentDate - birthday;

    const ageInMonths = Math.floor(
      ageInMilliseconds / (30 * 24 * 60 * 60 * 1000)
    ); // 30 ngày trong một tháng
    if (ageInMonths < 12) {
      return `${ageInMonths} tháng`;
    } else if (birthday.getFullYear() !== currentDate.getFullYear()) {
      const ageInYears = currentDate.getFullYear() - birthday.getFullYear();
      return ageInYears;
    }
  } else {
    return "";
  }
};
const toNumber = value => {
  return !isNaN(value) ? Number(value) : 0;
};
const exportFile = async (urlApi, params, nameFile, extension = "xlsx") => {
  try {
    const res = await axiosClient.get(urlApi, {
      params: params,
      responseType: "blob",
    });
    console.log(res.data);
    console.log(typeof res.data);
    var link = document.createElement("a");
    const url = window.URL.createObjectURL(res.data);
    link.href = url;
    link.download = `${nameFile}.${extension}`;
    link.click();
    Notification("success", "Đã xuất file báo cáo");
  } catch (error) {
    Notification("error", "Đã có lỗi khi xuất file báo cáo");
  }
};
const randomId = function (length = 6) {
  return Math.random()
    .toString(36)
    .substring(2, length + 2);
};
const convertBlockToWords = num => {
  const units = [
    "",
    "một",
    "hai",
    "ba",
    "bốn",
    "năm",
    "sáu",
    "bảy",
    "tám",
    "chín",
  ];
  const tens = [
    "",
    "mười",
    "hai mươi",
    "ba mươi",
    "bốn mươi",
    "năm mươi",
    "sáu mươi",
    "bảy mươi",
    "tám mươi",
    "chín mươi",
  ];
  const hundreds = [
    "",
    "một trăm",
    "hai trăm",
    "ba trăm",
    "bốn trăm",
    "năm trăm",
    "sáu trăm",
    "bảy trăm",
    "tám trăm",
    "chín trăm",
  ];

  let words = "";

  const hundred = Math.floor(num / 100);
  const ten = Math.floor((num % 100) / 10);
  const unit = num % 10;

  if (hundred > 0) {
    words += hundreds[hundred] + " ";
  }

  if (ten === 1) {
    words += "mười ";
  } else if (ten > 1) {
    words += tens[ten] + " ";
  }

  if (unit > 0) {
    // if (ten === 0 && hundred === 0) {
    //   words += "lẻ ";
    // }
    words += units[unit];
  }

  return words.trim();
};

const convertToWords = number => {
  const units = [
    "",
    "một",
    "hai",
    "ba",
    "bốn",
    "năm",
    "sáu",
    "bảy",
    "tám",
    "chín",
  ];
  const teens = [
    "mười",
    "mười một",
    "mười hai",
    "mười ba",
    "mười bốn",
    "mười năm",
    "mười sáu",
    "mười bảy",
    "mười tám",
    "mười chín",
  ];
  const tens = [
    "",
    "mười",
    "hai mươi",
    "ba mươi",
    "bốn mươi",
    "năm mươi",
    "sáu mươi",
    "bảy mươi",
    "tám mươi",
    "chín mươi",
  ];
  const thousands = ["", "nghìn", "triệu", "tỷ"];

  const numberStr = number.toString();
  const length = numberStr.length;

  if (length === 0) {
    return "Không";
  }

  let words = "";
  let blockCount = 0;
  let block = "";

  for (let i = length - 1; i >= 0; i--) {
    block = numberStr[i] + block;
    if (block.length === 3 || i === 0) {
      const num = parseInt(block, 10);
      if (num > 0) {
        const blockWords = convertBlockToWords(num);
        if (words !== "") {
          words = blockWords + " " + thousands[blockCount] + " " + words;
        } else {
          words = blockWords + " " + thousands[blockCount];
        }
      }
      block = "";
      blockCount++;
    }
  }
  if (number > 0) {
    return words + " đồng";
  } else return "";
};

const convertCurrencyToWords = number => {
  const chuHangDonVi = [
    " ",
    "một",
    "hai",
    "ba",
    "bốn",
    "năm",
    "sáu",
    "bảy",
    "tám",
    "chín",
  ];
  const chuHangChuc = [
    "lẻ",
    "mười",
    "hai",
    "ba",
    "bốn",
    "năm",
    "sáu",
    "bảy",
    "tám",
    "chín",
  ];
  const chuHangTram = [
    "không",
    "một",
    "hai",
    "ba",
    "bốn",
    "năm",
    "sáu",
    "bảy",
    "tám",
    "chín",
  ];
  const dvBlock = [" ", " nghìn ", " triệu ", " tỷ "];

  function convertTwoBlock(number) {
    const dv_index = parseInt(number.charAt(1));
    let dv = chuHangDonVi[dv_index];
    const chuc = chuHangChuc[parseInt(number.charAt(0))];
    let append = " ";
    if (parseInt(number.charAt(0)) > 0 && parseInt(number.charAt(1)) === 5) {
      dv = "lăm";
    }
    if (parseInt(number.charAt(0)) > 1) {
      append = " mươi ";
      if (parseInt(number.charAt(1)) === 1) {
        dv = "mốt";
      }
    }
    return chuc + append + dv;
  }

  function convertThreeBlock(number) {
    if (number === "000") {
      return " ";
    }
    switch (number.length) {
      case 0:
        return "";
      case 1:
        return chuHangDonVi[parseInt(number)];
      case 2:
        return convertTwoBlock(number);
      case 3:
        let chuc_dv = "";
        const two_block = number.substring(1, 3);
        if (two_block !== "00") {
          chuc_dv = convertTwoBlock(two_block);
          const char_0 = number.charAt(1);
          const temp = parseInt(number.charAt(0));
          const tram = chuHangTram[temp] + " trăm ";
          return tram + " " + chuc_dv;
        } else {
          const temp = parseInt(number.charAt(0));
          const tram = chuHangTram[temp] + " trăm ";
          return tram;
        }
    }
    return " ";
  }

  const toVietnamese = number => {
    const nb = number.toString();
    let result = "";
    const arr = [];
    let max_index = nb.length - 1;
    let index = nb.length;
    while (index >= 0) {
      if (index - 3 > 0) {
        arr.push(nb.substring(index - 3, index));
      } else {
        arr.push(nb.substring(0, index));
      }
      index -= 3;
    }
    const array_begin = [];
    const array_end = [];

    index = arr.length;
    let stt = 0;
    for (const item of arr) {
      if (item !== "" && item !== "000") {
        result = " " + convertThreeBlock(item);
        if (index > 0) {
          result += dvBlock[stt];
          index -= 1;
        }
        array_begin.push(result);
      }
      stt += 1;
    }
    result = "";
    index = array_begin.length;
    while (index > 0) {
      array_end.push(array_begin[index - 1]);
      index -= 1;
    }
    for (const item of array_end) {
      result += " " + item;
    }
    result = result.replace(/   /g, " ");
    result = result.replace(/  /g, " ");
    return result == " " ? "Không đồng" : result.trim() + " đồng";
  };

  // Sử dụng hàm
  // const chuTiengViet = toVietnamese(number);
  // Kết quả là "...đồng"
  const currencyToWords = toVietnamese(number);
  return currencyToWords;
};

const getLastValueBySplit = (data: String) => {
  let tmp = data?.trim()?.split("\n");
  if (tmp?.length > 0) {
    return tmp[tmp.length - 1];
  } else return null;
};

const renderGender = id => {
  if (id === 0) {
    return <div>Nam</div>;
  }
  if (id === 1) {
    return <div>Nữ</div>;
  }
};
const renderGenderText = id => {
  if (id === 0) {
    return "Nam";
  }
  if (id === 1) {
    return "Nữ";
  }
};

const convertStringToDetailTime = v => {
  const hours = Math.floor(v / 60);
  const minutes = v;
  return v ? <div>{v} phút</div> : "";
};
const moveElementToEnd = (arr, elementValue) => {
  const index = arr?.indexOf(elementValue);

  if (index !== -1) {
    arr?.splice(index, 1);
    arr?.push(elementValue);
  }
  return arr;
};

const isApproveRecord = (record: any) => {
  return record?.approval || false;
};
const jsonParse = str => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
};
const isValuableString = value => {
  return typeof value == "string" && value?.trim()?.length != 0;
};
const isValuable = value => {
  if (value != null && value != undefined) {
    return true;
  } else {
    return false;
  }
};
const toArray = data => {
  if (Array.isArray(data)) {
    return data;
  } else {
    return [];
  }
};
const isEqualArray = (array1, array2, exceptKeys) => {
  const _array1 = toArray(array1);
  const _array2 = toArray(array2);
  if (_array1.length != _array2.length) {
    return false;
  } else {
    const removeKeyArray1 = _array1.map(e => {
      return objectWithoutProperties(e, ["key"]);
    });
    const removeKeyArray2 = _array2.map(e => {
      return objectWithoutProperties(e, ["key"]);
    });

    return JSON.stringify(removeKeyArray1) == JSON.stringify(removeKeyArray2);
  }
};

const separateDate = inputDate => {
  const dateObject = moment(inputDate, "YYYY-MM-DD", true);

  if (dateObject.isValid()) {
    const year = dateObject.format("YYYY");
    const month = dateObject.format("MM");
    const day = dateObject.format("DD");

    return {year, month, day};
  } else {
    console.error("Invalid date format");
    return null;
  }
};
const removeDuplicateItemsInArray = array => {
  let set = new Set(toArray(array));
  let values = set.values();
  return Array.from(values);
};
const removeItemFromArray = (array, valueRemove) => {
  const filterArray = toArray(array)?.filter(value => value != valueRemove);
  return filterArray;
};
const removeItemsFromArray = (array, valuesRemove) => {
  const filterArray = toArray(array)?.filter(
    value => !toArray(valuesRemove)?.includes(value)
  );
  return filterArray;
};

const disableBtn = dateInput => {
  let checkDate = false;
  if (dateInput) {
    const ngayNhapVien = dayjs(dateInput);
    const ngayHienTai = dayjs().startOf("day");
    const ngaySauKhi = dayjs().endOf("day");

    if (
      (ngayNhapVien.isSame(ngayHienTai, "day") ||
        ngayNhapVien.isAfter(ngayHienTai, "day")) &&
      (ngayNhapVien.isSame(ngaySauKhi, "day") ||
        ngayNhapVien.isBefore(ngaySauKhi, "day"))
    ) {
      checkDate = false;
    } else {
      checkDate = true;
    }
  }
  return checkDate;
};
const setItemLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
  window.dispatchEvent(new Event("storage"));
};
const getItemLocalStorage = key => {
  return jsonParse(localStorage.getItem(key));
};
const convertAgeToWords = age => {
  const units = [
    "không",
    "một",
    "hai",
    "ba",
    "bốn",
    "năm",
    "sáu",
    "bảy",
    "tám",
    "chín",
  ];
  const tens = [
    "hai mươi",
    "ba mươi",
    "bốn mươi",
    "năm mươi",
    "sáu mươi",
    "bảy mươi",
    "tám mươi",
    "chín mươi",
  ];

  if (age < 10) {
    return units[age];
  } else if (age < 20) {
    const special = [
      "mười",
      "mười một",
      "mười hai",
      "mười ba",
      "mười bốn",
      "mười năm",
      "mười sáu",
      "mười bảy",
      "mười tám",
      "mười chín",
    ];
    return special[age - 10];
  } else {
    const firstDigit = Math.floor(age / 10);
    const secondDigit = age % 10;
    if (secondDigit === 0) {
      return tens[firstDigit - 2];
    } else {
      return tens[firstDigit - 2] + " " + units[secondDigit];
    }
  }
};
const checkAdminQuanLy = () => {
  const roles = localStorage.getItem("roles");
  return roles?.toString()?.includes("quanly_dichvu");
};
const checkAdmin = () => {
  const roles = localStorage.getItem("roles");
  return roles?.toString()?.includes("admin");
};
const capitalizeFirstLetter = str => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export {
  convertToWords,
  formatNumber,
  renderGender,
  formatToCurrencyType,
  formatDateToString,
  convertStringToDetailTime,
  convertIosStringToDate,
  convertIosStringToDateObjectDayjs,
  convertTimeSignatureToMins,
  validatePhoneNumberLength,
  saveTableOptions,
  getTableOptions,
  normalizePhoneNumber,
  removeSpaces,
  formatCodeField,
  removeObjUndefined,
  convertIosStringToDateDayjs,
  parseValueOfObjectToJson,
  getTodayString,
  randomId,
  getDateStringLocale,
  getAge,
  getBmi,
  dispatchCurrentRoom,
  saveLocalValueByUser,
  getLocalValueUser,
  checkEmptyObj,
  birthday2Age,
  toNumber,
  convertIosStringToDateObj,
  exportFile,
  convertIosStringToDateMoment,
  generateFileName,
  generateFileNameZip,
  renderSTT,
  objectWithoutProperties,
  convertIosStringToDate2,
  getLastValueBySplit,
  convertIosDateToString,
  formatToCurrencyTypeFloor,
  formatToCurrencyTypeToFixed,
  convertCurrencyToWords,
  moveElementToEnd,
  jsonParse,
  isValuable,
  isApproveRecord,
  birthday2AgeForConsultance,
  toArray,
  getDateStringLocaleDetail,
  isEqualArray,
  separateDate,
  formatToCurrencyTypeNoFloor,
  removeDuplicateItemsInArray,
  removeItemFromArray,
  removeItemsFromArray,
  renderGenderText,
  formatDateOrStringToStringGMT_7,
  convertDateStringToDateTimezone_7,
  formatDateToStringTimezone_7,
  convertDateStringToDateTimezone_7Dayjs,
  disableBtn,
  setItemLocalStorage,
  getItemLocalStorage,
  convertAgeToWords,
  isValuableString,
  checkAdminQuanLy,
  convertDateStringToDateTimezone_7DayjsNotValid,
  capitalizeFirstLetter,
  formatDateToStringUnix,
  checkAdmin,
  convertDateStringToDateDayjs,
  formatDate,
  formatDateDelete,
};
